
import Vue from "vue";
import { FIcon } from "@fkui/vue";
import { ContainerSlot } from "@/store/types";
export default Vue.extend({
    name: "ContainerButton",
    components: {
        FIcon,
    },
    props: {
        container: {
            type: Object as () => ContainerSlot,
            required: true,
        },
    },
    computed: {
        isClosed(): boolean {
            return !this.container.isOpen && this.container.isAnyFieldTouched;
        },
        isInitial(): boolean {
            return !this.container.isOpen && !this.container.isAnyFieldTouched && !this.container.isValid;
        },
    },
});
